<template>
    <div v-if="!isMobile">
        <div class="tableCard" v-for="(item,i) in commandes" :key="item.id_commande">
            <div class="header">
                <div class="item">
                    <img class="logo"
                         v-lazy="`${$common.imgHost}Images/Boutiques/`+ item.id_vendeur + '/logo-boutique.jpg'"
                         alt/>
                </div>
                <div class="item">
                    <div>
                        <span class="bold-text">{{ langPage['panier-resume']['TXT_grossistes'] }}</span>
                        <p>{{ item.vendeur.nomSociete }}</p>
                    </div>
                    <div>
                        <span class="bold-text">{{ langPage['bov-commandes-liste']['TXT_id'] }}</span>
                        <p>{{ `#${item.id_commande_groupe}` }}</p>
                    </div>
                    <div>
                        <span class="bold-text">

                        </span>
                        <p>{{ `#${formatUtils.parseTime(item.dateCreation, '{m}/{d}/{y}')}` }}</p>
                    </div>
                    <!-- <div class="pt">
                      <span>STATUS</span>
                      <p>
                        <span class="rond"></span>
                        En attente de confirmation
                      </p>
                    </div>-->
                </div>
                <div class="item">
                    <section>
                        <div v-if="(!item.dateExpedition && item.commandes_statut.id_statut!=2) || moment().diff(moment(item.dateExpedition),'days')<7"
                             @click="onClickShowContactEfashion(item)">
                            <img src="@/assets/img/rotate-back.svg" alt/>
                            <span>{{ langPage['v4-tablecard']['TXT_effectuerunretour'] }}</span>
                        </div>
                        <a :href="base.dev + `/v2/produits/downloadPictures?id_commande=${item.id_commande}`"
                           @click="onClickDownloadOrderImg"
                           v-loading="is_downloading_prod_file">
                            <div>
                                <img src="@/assets/img/photo.svg" alt/>
                                <span>{{ langPage['compte-commandes-details']['TXT_telechargerphotos'] }}</span>
                            </div>
                        </a>
                        <div @click="onClickDownloadOrderBillImg(item)">
                            <img src="@/assets/img/task.svg" alt/>
                            <span>{{ langPage['bov-commandes-recapitulatifs']['TXT_voirfacture'] }}</span>
                        </div>
                        <div @click="onClickDownloadTransport(item)">
                            <img src="@/assets/img/task.svg" alt/>
                            <span>{{ `la facture frais port` }}</span>
                        </div>
                        <div style="display: inline-block">
                            <span>{{ langPage['v4-tablecard']['TXT_commandestatut'] }}: </span>
                            <div>
                                <span class="rond color-other"
                                      v-bind:class="{
                                color1:item.commandes_statut.id_statut==1,
                                color2:item.commandes_statut.id_statut==2,
                                color3:item.commandes_statut.id_statut==3,}">
                                </span>
                                <span>{{ item.commandes_statut[`statut_${lang}`] }}</span>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div class="th">
                <el-collapse style="width:100%">
                    <el-collapse-item>
                        <template slot="title">
                            <i class="el-icon-plus dis"></i>
                            <span class="bold-text">{{ langPage['v4-tablecard']['TXT_colistracking'] }}</span>
                        </template>
                        <div class="item">
                            <div class="pt">
                                <!-- <span class="bold-text">Colis & tracking</span> -->
                                <div v-for="(transport,transportIndex) of transportHelper.getTransportData(command_group)[i]"
                                     :key="transportIndex">
                                    <p>
                                        <span class="transportNo">
                                        {{ !commonUtils.isEmpty(transport) ? transport.name + ' ' + transport.transportOrderId : '' }}
                                        </span>
                                    </p>
                                    <p v-if="item.commandes_etiquettes[0]" class="voir" @click="onClickTurnToTransport(transport)">
                                        {{ langPage['v4-tablecard']['TXT_voirtracking'] }}</p>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div class="cont">
                <el-collapse style="width:100%">
                    <el-collapse-item>
                        <template slot="title">
                            <i class="el-icon-plus dis"></i>
                            <span class="bold-text">{{ langPage['v4-tablecard']['TXT_articlesetquantites'] }}</span>
                        </template>
                        <div class="flex" v-for="(prod,i) in item.produits" :key="prod.id_produit">
                            <img
                                class="img"
                                fit="cover"
                                :lazy='true'
                                @click="$router.push(`/ProductDetail?id=${prod.id_produit}&vendu_par=${prod.vendu_par}&vid=${prod.id_vendeur}&categorie_id=${prod.id_categorie}`)"
                                v-lazy="`${$common.imgHost}Images/Boutiques/${prod.id_vendeur}/Produits/accueil/${prod.id_produit}-c.jpg`"
                            />
                            <div class="left">
                                <div class="item color">
                                    <el-popover
                                        placement="top-start"
                                        trigger="hover"
                                        :content="prod.reference">
                                        <p slot="reference">#{{
                                                prod.reference.substr(0, 6) + `${prod.reference.length > 6 ? '...' : ''}`
                                            }}</p>
                                    </el-popover>
                                    <div class="cercle">
                                        <span
                                            :style="{backgroundColor:typeof prod.couleur_value==='string'?prod.couleur_value:(prod.couleur_value?prod.couleur_value[0]:'')}"></span>
                                        <div>{{
                                                typeof
                                                    prod.couleur_value === 'string' ? prod.couleur_name : prod.couleur_name[0]
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="size">
                                    <div class="sku">
                                        <div v-for="(size,sizeIndex) in prod.sizeList"
                                             class="item">
                                            <p>{{ size.size }}</p>
                                            <span v-if="prod.vendu_par!='tailles'">{{ size.num * prod.copeText }}</span>
                                            <span v-else type="text" v-text="size.num"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="price">
                                    <div class="total">
                                        <!--                                        <div class="item" v-if="prod.vendu_par!='tailles'">-->
                                        <!--                                            <p>{{ langPage['produits']['TXT_paquets'] }}</p>-->
                                        <!--                                            <span>{{prod.pack_qte}}</span>-->
                                        <!--                                            &lt;!&ndash; <span>{{prod.lignes.quantite_pack}}</span> &ndash;&gt;-->
                                        <!--                                        </div>-->
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_totalqte'] }}</p>
                                            <span
                                                v-if="prod.vendu_par!=='tailles'">{{
                                                    prod.packTotal * prod.copeText
                                                }}</span>
                                            <span v-else>{{ prod.qteTotal }}</span>
                                            <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_puht'] }}</p>
                                            <span :class="{'item-other':prod.prixReduit}">{{ prod.prix }} €</span>
                                            <span v-if="prod.prixReduit">{{ prod.prixReduit }} €</span>
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] }}</p>
                                            <span v-if="prod.vendu_par!=='tailles'">
                                        {{
                                                    (prod.prixReduit ? prod.prixReduit * (prod.packTotal * prod.copeText) : prod.prix * (prod.packTotal * prod.copeText)).toFixed(2)
                                                }}€</span>
                                            <span
                                                v-else>{{
                                                    (prod.prixReduit ? prod.prixReduit * prod.qteTotal : prod.prix * prod.qteTotal)
                                                }}€</span>
                                        </div>
                                    </div>
                                </div>
                                <section class="line"></section>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="bottom">
                <div class="left">
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_totalqte'] | toUpperCase }}</span>
                        <span>{{ item.commande_total_qte }}</span>
                    </div>
                    <button @click="onClickRetryBuy(item)" style="cursor: pointer">
                        {{ langPage['v4-tablecard']['TXT_commanderanouveau'] }}
                    </button>
                </div>
                <div class="right">
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_articlesht']| toUpperCase }}</span>
                        <p>{{ item.montantTotal }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['boa-temp-vendeursfacturation']['TXT_remiseht'] | toUpperCase }}</span>
                        <p>{{ item.total_remise }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] | toUpperCase }}</span>
                        <p>{{ item.montantApresRemise }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_totaltva'] }}</span>
                        <p>{{ item.total_tva }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalttc'] | toUpperCase }}</span>
                        <p>{{ item.total_ttc }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['panierv2']['TXT_fraisdeport'] | toUpperCase }}</span>
                        <p>{{ command_group.frais_port_src }} €</p>
                    </div>
                </div>
            </div>
            <el-dialog :title="`contact efashion`" :visible.sync="showContactDialog" :close-on-click-modal="true">
                <div class="contactDialog">
                    <p class="content">{{ `ID COMMANDE GROUP : ${contactCommande.id_commande_groupe}` }}</p>
                    <!--                    <p class="content">{{ `COMMANDE : ${contactCommande.id_commande_name}` }}</p>-->
                    <p class="content">{{ `VENDEUR : ${contactCommande.vendeur.nomSociete}` }}</p>
                    <el-select class="content" v-model="contactParams.orderErrorType"
                               :placeholder="langPage['v4-topmenu']['TXT_choisirvotresujet']"
                               @change="onChangeContactErrorType">
                        <el-option
                            v-for="item in orderErrorTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="content">{{ langPage['v4-tablecard']['TXT_message'] }}:</p>
                    <el-input class="content" type="textarea" v-model="contactParams.message" :rows="3"></el-input>
                    <el-upload
                        :auto-upload="false"
                        :on-change="onChangeUploadFile"
                        :limit="1">
                        <el-button size="small" type="primary">
                            {{ langPage['v4-inscription-grossistes']['TXT_choisirunfichir'] }}
                        </el-button>
                    </el-upload>
                    <vue-recaptcha class="recaptcha" ref="recaptcha" :sitekey="$common.recaptchaKey"
                                   @verify="recaptchaVerified"
                                   :loadRecaptchaScript="true">
                    </vue-recaptcha>
                    <el-button @click="subContactMsg" class="content" type="primary">
                        {{ langPage['v4-tablecard']['TXT_send'] }}
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
    <div v-else>
        <div class="mtableCard" v-for="(item,i) in commandes" :key="item.id_commande">
            <div class="header">
                <div class="item">
                    <img class="logo"
                         v-lazy="`${$common.imgHost}Images/Boutiques/`+ item.id_vendeur + '/logo-boutique.jpg'"
                         alt/>
                </div>
                <div class="item">
                    <div>
                        <span class="bold-text">{{ langPage['panier-resume']['TXT_grossistes'] }}</span>
                        <p>{{ item.vendeur.nomSociete }}</p>
                    </div>
                    <div>
                        <span class="bold-text">{{ langPage['bov-commandes-liste']['TXT_id'] }}</span>
                        <p>{{ `#${item.id_commande_name}` }}</p>
                    </div>
                    <div>
                        <span class="bold-text">{{ langPage['bov-commandes-recapitulatifs']['TXT_date'] }}</span>
                        <p>{{ `#${formatUtils.parseTime(item.dateCreation, '{m}/{d}/{y}')}` }}</p>
                    </div>
                    <!-- <div class="pt">
                      <span>STATUS</span>
                      <p>
                        <span class="rond"></span>
                        En attente de confirmation
                      </p>
                    </div>-->
                </div>
                <section class="orderMenu">
                    <div v-if="(!item.dateExpedition && item.commandes_statut.id_statut!=2) || moment().diff(moment(item.dateExpedition),'days')<7"
                         @click="onClickShowContactEfashion(item)">
                        <img src="@/assets/img/rotate-back.svg" alt/>
                        <span>{{ langPage['v4-tablecard']['TXT_effectuerunretour'] }}</span>
                    </div>
                    <a :href="base.dev + `/v2/produits/downloadPictures?id_commande=${item.id_commande}`"
                       @click="onClickDownloadOrderImg"
                       v-loading="is_downloading_prod_file">
                        <div>
                            <img src="@/assets/img/photo.svg" alt/>
                            <span>{{ langPage['compte-commandes-details']['TXT_telechargerphotos'] }}</span>
                        </div>
                    </a>
                    <div @click="onClickDownloadOrderBillImg(item)">
                        <img src="@/assets/img/task.svg" alt/>
                        <span>{{ langPage['compte-commandes-liste']['TXT_facture'] + langPage['compte-commandes-liste']['TXT_fraisdeport'] }}</span>
                    </div>
                    <div @click="onClickDownloadTransport(item)">
                        <img src="@/assets/img/task.svg" alt/>
                        <span>{{ `la facture frais port` }}</span>
                    </div>
                    <div>
                        <span>{{ langPage['v4-tablecard']['TXT_commandestatut'] }}: </span>
                        <span class="rond color-other"
                              v-bind:class="{
                                color1:item.commandes_statut.id_statut==1,
                                color2:item.commandes_statut.id_statut==2,
                                color3:item.commandes_statut.id_statut==3,}">
                                </span>
                        <span>{{ item.commandes_statut[`statut_${lang}`] }}</span>
                    </div>
                </section>
            </div>

            <div class="th">
                <el-collapse style="width:100%">
                    <el-collapse-item>
                        <template slot="title">
                            <i class="el-icon-plus dis"></i>
                            <span class="bold-text">{{ langPage['v4-tablecard']['TXT_colistracking'] }}</span>
                        </template>
                        <div class="item">
                            <div class="pt">
                                <!-- <span class="bold-text">Colis & tracking</span> -->
                                <div v-for="(transport,transportIndex) of transportHelper.getTransportData(command_group)[i]"
                                     :key="transportIndex">
                                    <p>
                                        <span class="transportNo">
                                        {{ !commonUtils.isEmpty(transport) ? transport.name + ' ' + transport.transportOrderId : '' }}
                                        </span>
                                    </p>
                                    <p v-if="item.commandes_etiquettes[0]" class="voir" @click="onClickTurnToTransport(transport)">
                                        {{ langPage['v4-tablecard']['TXT_voirtracking'] }}</p>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div class="contBox">
                <el-collapse style="width:100%">
                    <el-collapse-item>
                        <template slot="title">
                            <i class="el-icon-plus dis"></i>
                            <span class="bold-text">{{ langPage['v4-tablecard']['TXT_articlesetquantites'] }}</span>
                        </template>
                        <div class="cont">
                            <template
                                v-if="item && item.produits && item.produits.length>0">
                                <div class="container" v-for="(prod,i) in item.produits" :key="i">
                                    <div class="productImgBox">
                                        <el-image
                                            :lazy='true'
                                            class="img"
                                            fit="cover"
                                            @click="$router.push(`/ProductDetail?id=${prod.id_produit}&vendu_par=${prod.vendu_par}&vid=${prod.id_vendeur}&categorie_id=${prod.id_categorie}`)"
                                            :src="prod.produit_url"></el-image>
                                        <div class="desc">
                                            <p>{{ prod.reference }}</p>
                                            <div class="cercle">
                                                <span
                                                    :style="{backgroundColor:typeof prod.couleur_value==='string'?prod.couleur_value:(prod.couleur_value?prod.couleur_value[0]:'')}"></span>
                                                <div>{{
                                                        typeof
                                                            prod.couleur_value === 'string' ? prod.couleur_name : prod.couleur_name[0]
                                                    }}
                                                </div>
                                            </div>
                                            <span class="tips">{{
                                                    langPage['v4-panier']['TXT_sauvegarderpourplustard']
                                                }}</span>
                                        </div>
                                    </div>
                                    <el-divider></el-divider>
                                    <el-row type="flex" align="middle" class="size">
                                        <div class="sku">
                                            <div v-for="(size,sizeIndex) in prod.sizeList"
                                                 class="item"
                                                 :key="sizeIndex">
                                                <p>{{ size.size }}</p>
                                                <span
                                                    v-if="prod.vendu_par!='tailles'">{{
                                                        size.num * prod.copeText
                                                    }}</span>
                                                <input
                                                    type="text"
                                                    v-model="size.num"
                                                    v-else
                                                    @blur="tailBlur(prod,sizeIndex,maq)"
                                                    @input="tailInput(prod,size.num,sizeIndex)"
                                                    oninput="value=value.replace(/[^\d|0]/g, '')"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <el-row type="flex" align="middle" class="paquest"
                                                    v-show="prod.vendu_par!='tailles'">
                                                <p>{{ langPage['produits']['TXT_paquets'] }}</p>
                                                <span>{{ prod.copeText }}</span>
                                            </el-row>
                                        </div>
                                    </el-row>
                                    <el-divider></el-divider>
                                    <div class="price">
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_totalqte'] }}</p>
                                            <span
                                                v-if="prod.vendu_par!=='tailles'">{{
                                                    prod.packTotal * prod.copeText
                                                }}</span>
                                            <span v-else>{{ prod.qteTotal }}</span>
                                            <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_puht'] }}</p>
                                            <span :class="{'item-other':prod.prixReduit}">{{ prod.prix }} €</span>
                                            <span v-if="prod.prixReduit">{{ prod.prixReduit }} €</span>
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] }}</p>
                                            <span v-if="prod.vendu_par!=='tailles'">
                                                            {{
                                                    (prod.prixReduit ? prod.prixReduit * (prod.packTotal * prod.copeText) : prod.prix * (prod.packTotal * prod.copeText)).toFixed(2)
                                                }}€</span>
                                            <span v-else>
                                                            {{
                                                    (prod.prixReduit ? prod.prixReduit * (prod.qteTotal) : prod.prix * (prod.qteTotal)).toFixed(2)
                                                }}€</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="bottom">
                <div class="left">
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_totalqte'] | toUpperCase }}</span>
                        <span>{{ item.commande_total_qte }}</span>
                    </div>
                    <button @click="onClickRetryBuy(item)">Commander à nouveau</button>
                </div>
                <div class="right">
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_articlesht']| toUpperCase }}</span>
                        <p>{{ item.montantTotal }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['boa-temp-vendeursfacturation']['TXT_remiseht'] | toUpperCase }}</span>
                        <p>{{ item.total_remise }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] | toUpperCase }}</span>
                        <p>{{ item.montantApresRemise }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_totaltva'] }}</span>
                        <p>{{ item.total_tva }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalttc'] | toUpperCase }}</span>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalttc'] | toUpperCase }}</span>
                        <p>{{ item.total_ttc }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['panierv2']['TXT_fraisdeport'] | toUpperCase }}</span>
                        <p>{{ command_group.frais_port_src }} €</p>
                    </div>
                </div>
            </div>
            <el-dialog :title="`contact efashion`" :visible.sync="showContactDialog" :close-on-click-modal="true">
                <div class="contactDialog">
                    <p class="content">{{ `ID COMMANDE GROUP : ${contactCommande.id_commande_groupe}` }}</p>
                    <!--                    <p class="content">{{ `COMMANDE : ${contactCommande.id_commande_name}` }}</p>-->
                    <p class="content">{{ `VENDEUR : ${contactCommande.vendeur.nomSociete}` }}</p>
                    <el-select class="content" v-model="contactParams.orderErrorType"
                               :placeholder="langPage['v4-topmenu']['TXT_choisirunsujet']"
                               @change="onChangeContactErrorType">
                        <el-option
                            v-for="item in orderErrorTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="content">{{ langPage['v4-tablecard']['TXT_message'] }}:</p>
                    <el-input class="content" type="textarea" v-model="contactParams.message" :rows="3"></el-input>
                    <el-upload
                        :auto-upload="false"
                        :on-change="onChangeUploadFile"
                        :limit="1">
                        <el-button size="small" type="primary" class="content">
                            {{ langPage['v4-inscription-grossistes']['TXT_choisirunfichir'] }}
                        </el-button>
                    </el-upload>
                    <el-button @click="subContactMsg" class="content" type="primary">
                        {{ langPage['v4-tablecard']['TXT_send'] }}
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import base from "../../../api/base";
import {mapState} from "vuex";
import VueRecaptcha from 'vue-recaptcha';

let formatUtils = require('@/utils/format');
let transportHelper = require('@/utils/helper/Checkout/transport_helper');
let commonUtils = require('@/utils/common_utils');
let moment = require('moment');
export default {
    name: "tableCard",
    props: {
        dataAll: Object,
    },
    watch: {
        dataAll(value) {
            this.dataAllReal = value;
            this.command_group = this.dataAll.command_group;
            this.commandes = this.dataAll.commandes;
            this.command_group.commandes = this.commandes;
            this.initData();
        }
    },
    components: {
        VueRecaptcha
    },
    filters: {
        toUpperCase(val) {
            if (!val) return "";
            return val.toUpperCase();
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            lang: this.$store.state.lang,
            color: "red",
            activeNames: [],
            dataAllReal: {},
            command_group: {},
            commandes: [],
            formatUtils: formatUtils,
            transportHelper: transportHelper,
            commonUtils: commonUtils,
            showContactDialog: false,
            contactCommande: {
                vendeur: {}
            },
            contactParams: {
                orderErrorType: '',
                message: '',
            },
            orderErrorTypeList: [
                {
                    value: this.$t("moncompte_articles.word1"),
                    label: this.$t("moncompte_articles.word1")
                },
                {
                    value: this.$t("moncompte_articles.word2"),
                    label: this.$t("moncompte_articles.word2")
                },
                {
                    value: this.$t("moncompte_articles.word3"),
                    label: this.$t("moncompte_articles.word3")
                },
                {
                    value: this.$t("moncompte_articles.word7"),
                    label: this.$t("moncompte_articles.word7")
                },
            ],
            robotToken: '',
            uploadFile: [],//要上传的文件
            moment: moment,
            is_downloading_prod_file: false,//是否正在下载产品图片
            base: base,
        };
    },
    mounted() {
        this.dataAllReal = this.dataAll;
        this.command_group = this.dataAll.command_group;
        this.commandes = this.dataAll.commandes;
        this.initData();
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    methods: {
        initData() {
            for (let item of this.commandes) {
                console.log('transportData1', item)
                if (commonUtils.isEmpty(item.commandes_etiquettes) || !item.commandes_etiquettes[0].etiquette) {
                    continue;
                }
                let transportData = JSON.parse(item.commandes_etiquettes[0].etiquette);
                item.livraison.transportData = transportData;
                console.log('transportData2', item.livraison)
            }
        },
        onClickDownloadOrderImg(item) {
            if (this.is_downloading_prod_file) return;
            this.is_downloading_prod_file = true;
            let that = this;
            setTimeout(function () {
                that.is_downloading_prod_file = false;
                that.$forceUpdate();
            }, 20000);
        },
        onClickDownloadOrderBillImg(item) {
            let downloadTime = moment(item.dateCommande).format('yyyy-MM');
            console.log(downloadTime)
            let obj = {...item};
            obj.downloadTime = downloadTime;

            let vendeurName = obj.vendeur.nomSociete.toLowerCase();
            vendeurName = vendeurName.replaceAll(' ', '-');
            const pattern = /[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
            vendeurName = vendeurName.replaceAll(pattern, '');
            //https://www.efashion-paris.com/front/files/commandes/factures/2020-09(订单年-月)/258572（id_commande_groupe）/1965782(id_commande)-1(文件数)-popindiff（商家名称）.pdf
            let url = `${this.$common.imgHost}front/files/commandes/factures/${obj.downloadTime}/${obj.id_commande_groupe}/${obj.id_commande}-1-${vendeurName}.pdf`;
            window.open(url, '_blank');
            // this.$api.order.onClickDownloadOrderBillImg(obj).then(res => {
            //     console.log(res);
            // });
        },
        //跳转到物流公司的详情过去
        onClickTurnToTransport(transport) {
            if (!transport.url) return this.$message.error(`can't get deliver data`);
            window.open(transport.url, '_blank');
        },
        //点击下载运费账单
        onClickDownloadTransport(item) {
            console.log(item);
            let lang = this.$store.state.lang == 'fr' ? 'fr' : 'uk';
            let url = `${this.$common.imgHost}facturePDF/${lang}/${this.$store.state.userInfo.id_acheteur}/${item.id_commande_groupe_name + lang.toUpperCase()}.pdf`
            console.log(url)
            // return;
            window.open(url, '_blank');
        },
        onClickRetryBuy(item) {
            console.log('retryBuy', item);
            if (!item || !item.ligne || item.ligne.length < 1) return this.$message.error('data error');
            let arr = item.ligne;
            for (let ligneItem of arr) {
                delete ligneItem.id_ligne;
                delete ligneItem.id_commande;
                delete ligneItem.corbeille;
                delete ligneItem.prixLigne;
                delete ligneItem.poids;
                delete ligneItem.degressif;
                delete ligneItem.date_creation;
                delete ligneItem.date_modification;
            }
            this.$api.sort.addOrder({
                "id_vendeur": item.id_vendeur,
                "lignes": arr
            }).then(res => {
                this.$message.success(this.$t("product_detail.word1"));
            }).catch(err => {
                this.$message.error(err);
            })
        },
        //显示联系订单数据
        onClickShowContactEfashion(item) {
            this.contactCommande = item;
            this.showContactDialog = true;
        },
        //提交联系信息
        subContactMsg() {
            if (!this.contactParams.orderErrorType || !this.contactParams.message || !this.robotToken) {
                return this.$message.error(`message or robot verify or order error can't null`);
            }
            let tempParams = {
                order_error_type: this.contactParams.orderErrorType,
                order: JSON.stringify(this.contactCommande),
                msg: this.contactParams.message,
                robotToken: this.robotToken,
            };
            let param = new FormData();
            for (let key of Object.keys(tempParams)) {
                if (tempParams[key]) {
                    param.append(key, tempParams[key]);
                }
            }
            param.append('file', this.uploadFile);
            this.$api.info.order_after_contact_admin(param).then(res => {
                if (res.code === 0) {
                    this.$message.success(res.message);
                    this.showContactDialog = false;
                } else this.$message.error(res.message);
            });
        },
        //监听修改了联系消息的错误类型
        onChangeContactErrorType(errorType) {
            let index = -1;
            for (let errorObj of this.orderErrorTypeList) {
                if (errorObj.value === errorType) {
                    index = this.orderErrorTypeList.indexOf(errorObj);
                }
            }
            this.contactParams.message = this.$t(`moncompte_articles.word${index + 4}`);
        },
        recaptchaVerified(token) {
            this.robotToken = token;
        },
        //监听上传文件修改
        onChangeUploadFile(file, fileList) {
            this.uploadFile = file.raw;
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Articles/tableCard.less">
</style>
